import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomersRoutingModule } from './customers-routing.module';
import { CustomersComponent } from './customers.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SharedModule } from 'src/app/shared';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { CustomersGroupModule } from './customers-group/customers-group.module';
import { CallModule } from './call/call.module';
@NgModule({
  declarations: [
    CustomersComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomersRoutingModule,
    NgZorroAntdModule,
    SharedModule,
    NzTabsModule,
    CustomersGroupModule,
    CallModule,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class CustomersModule { }
